import classNames from 'classnames';
import { ReactNode } from 'react';

export const FELT_CARD_BACK_CLASS_NAME =
  'block max-w-none w-[calc(58*var(--card-unit))] h-[calc(84*var(--card-unit))] rounded-[6px] object-cover outline-1 -outline-offset-1 outline-black/25';

export function EmptySlot({
  className,
  children,
}: {
  className: string;
  children?: ReactNode;
}) {
  return (
    <span
      className={classNames(
        'flex items-center justify-center rounded-[10px] border-2 border-dashed border-white/30 text-[13px] font-semibold text-felt-ink-muted',
        className
      )}
    >
      {children}
    </span>
  );
}

export function FlameIcon({ size }: { size: number }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="currentColor"
      aria-hidden="true"
    >
      <path d="M12 2c.8 3.6 5.5 5.6 5.5 11a5.5 5.5 0 0 1-11 0c0-2.6 1.3-4.2 2.6-5.3.1 2 1 3.3 2.3 3.6C10.8 8.4 10.6 4.8 12 2z" />
    </svg>
  );
}

export function FeltTexture() {
  return (
    <div
      aria-hidden="true"
      className="pointer-events-none absolute inset-0 -z-10 overflow-hidden rounded-[inherit] opacity-30"
    >
      <svg width="100%" height="100%" className="block">
        <filter id="felt-texture">
          <feTurbulence
            type="fractalNoise"
            baseFrequency="0.95"
            numOctaves="2"
            seed="2"
          />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0  0 0 0 0 0  0 0 0 0 0  0.9 0 0 0 -0.25"
          />
        </filter>
        <rect width="100%" height="100%" filter="url(#felt-texture)" />
      </svg>
    </div>
  );
}
